import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useDashboardStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/dashboard/stats").then((r) => { if (alive) setStats(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return stats;
}
